// RIBBON rowsets — explicit registration (no side-effect-on-import modules;
// hosts call registerBuiltinRowsets() once before rendering <Ribbon/>).
// R0's lab does; the R1 mount will do the same.
import { registerRow1Rowset, registerRow2Rowset } from '../core/rowsetRegistry.mjs';
import textRow1 from './textRow1.mjs';
import shapeRow1 from './shapeRow1.mjs';
import imageRow1 from './imageRow1.mjs';
import iconRow1 from './iconRow1.mjs';
import pageRow1 from './pageRow1.mjs';
import smartRow1 from './smartRow1.mjs';
import universalRow2 from './universalRow2.mjs';

export function registerBuiltinRowsets() {
  registerRow1Rowset('text', textRow1);
  registerRow1Rowset('shape', shapeRow1);
  registerRow1Rowset('image', imageRow1);
  // Icons are FabricImages with isIcon — their own morph (tint, flips): the
  // photo set (crop/frame/remove-BG) would be dishonest on a decorative
  // cutout. The mount derives kind 'icon' from the flag.
  registerRow1Rowset('icon', iconRow1);
  // Smart objects are Groups with a registered recipe — their own morph (the
  // Tool options… button; Smart Tools epic 2026-07-23). Mount derives
  // row1Kind 'smart' from the smartRecipeName mirror.
  registerRow1Rowset('smart', smartRow1);
  registerRow1Rowset('none', pageRow1);
  registerRow2Rowset(universalRow2);
}

export { textRow1, shapeRow1, imageRow1, iconRow1, pageRow1, smartRow1, universalRow2 };
